import iconBook from "../../../../assets/icons/ic-book.png";
import iconUser from "../../../../assets/icons/ic-user.png";
import iconCalendar from "../../../../assets/icons/ic-calendar.png";
import "../index.scss";
import moment from "moment";
import utils from "../../../../core/utils";
import constant from "../../../../core/constant";
import LoginModal from "../components/loginModal";
import ConfirmBookingModal from "../components/confirmBookingModal";
import ConfirmRemoveModal from "../components/confirmRemoveModal";
import { Component } from "react";
import GoToHistoryButton from "../../../shared/top-button";
import { ButtonStyled, ColorWrapper, RequiredLabel } from "./common-styled";

const removeDialog = {
  menu: "menu",
  staff: "staff",
  time: "time",
};

class DefaultContainer extends Component {
  constructor(props) {
    super(props);
    this.dispatch = props.dispatchActions;
    this.pageColor = props.user.shopDetail.color || "#fd666c";
    this.state = {
      listStaff: [],
      listDiscount: [],
      listMenu: [],
      shopId: props.match.params.id,
      errorMessages: [],
      isShowLoginModal: false,
      userAccount: "",
      userPassword: "",
      isShowConfirmBookingModal: false,
      isShowRemoveDialog: false,
      removeType: "",
      willRemoveThing: "",
      otherDiscountValue: "",
      timeDiscountValue: "",
      totalDiscountValue: "",
    };
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  componentDidMount() {
    const { timeDiscount, otherDiscount, discount, total } =
      this.props.user.userBookingData;
    if (timeDiscount) {
      const timeDiscountValue = this.getDiscountValue(timeDiscount, total);
      this.setState({
        timeDiscountValue,
      });
    }

    if (otherDiscount) {
      this.setState({
        otherDiscountValue: otherDiscount.value_other,
      });
    }
  }

  getDiscountValue(discount, total) {
    if (discount.type === "Other") return discount.value_other;
    if (discount.type === "Percentage") {
      if (!total) return null;
      return (+discount.value * +total) / 100;
    }
    if (discount.type === "Fixed") return +discount.value;
    return null;
  }

  remove = (type) => {
    this.setState({ isShowRemoveDialog: true, removeType: type });
  };

  isValidDiscount = (discount) => {
    const chosenTime = this.props.user.userBookingData.chosenTime;
    if (!chosenTime) return true;
    return (
      discount &&
      moment(
        moment(discount.valid_to).format("YYYY-MM-DD HH:mm")
      ).isSameOrAfter(
        moment(chosenTime || new Date()).format("YYYY-MM-DD HH:mm")
      ) &&
      moment(
        moment(discount.valid_from).format("YYYY-MM-DD HH:mm")
      ).isSameOrBefore(
        moment(chosenTime || new Date()).format("YYYY-MM-DD HH:mm")
      )
    );
  };

  removeMenu = (menu) => {
    if (this.props.user.confirmWhenRemove === true) {
      this.setState({
        isShowRemoveDialog: true,
        removeType: removeDialog.menu,
        willRemoveThing: menu,
      });

      return;
    }

    const listChosen = this.props.user.userBookingData.chosenMenu.split(",");
    const index = listChosen.findIndex((item) => +item === menu.id);
    listChosen.splice(index, 1);

    const totalMoney = listChosen
      .map((chosen) =>
        this.props.user.shopMenus.find((menu) => +chosen === menu.id)
      )
      .reduce((acc, curr) => {
        return (acc += Number(curr.price));
      }, 0);

    const totalDuration = listChosen
      .map((chosen) =>
        this.props.user.shopMenus.find((menu) => +chosen === menu.id)
      )
      .reduce((acc, curr) => {
        return (acc += Number(curr.duration));
      }, 0);

    const totalDiscount = listChosen
      .map((chosen) =>
        this.props.user.shopMenus.find((menu) => +chosen === menu.id)
      )
      .reduce((acc, curr) => {
        const discount = this.props.user.shopDiscounts.find(
          (item) => curr.discount === item.id
        );

        let amount = acc;

        if (this.isValidDiscount(discount)) {
          if (discount.type === "Percentage") {
            amount += (+discount.value * +curr.price) / 100;
          } else {
            amount += +discount.value;
          }
        }
        return amount;
      }, 0);

    const userBookingData = {
      ...this.props.user.userBookingData,
      total: totalMoney,
      duration: totalDuration,
      discount: totalDiscount,
      chosenMenu: listChosen.join(","),
    };

    this.dispatch.setUserBookingData({
      key: this.state.shopId,
      value: userBookingData,
    });
  };

  removeStaff = (staff) => {
    if (this.props.user.confirmWhenRemove === true) {
      this.setState({
        isShowRemoveDialog: true,
        removeType: removeDialog.staff,
        willRemoveThing: staff,
      });

      return;
    }

    const userBookingData = {
      ...this.props.user.userBookingData,
      chosenStaff: "",
    };
    this.dispatch.setUserBookingData({
      key: this.state.shopId,
      value: userBookingData,
    });
  };

  removeChosenTime = (chosenTime) => {
    if (this.props.user.confirmWhenRemove === true) {
      this.setState({
        isShowRemoveDialog: true,
        removeType: removeDialog.time,
        willRemoveThing: chosenTime,
      });

      return;
    }

    const userBookingData = {
      ...this.props.user.userBookingData,
      chosenTime: "",
      isUserChosenTime: false,
    };
    this.dispatch.setUserBookingData({
      key: this.state.shopId,
      value: userBookingData,
    });
  };

  changePage = (path) => {
    this.props.history.push(path);
  };

  onCloseLoginModal = (data) => {
    this.setState({
      isShowLoginModal: false,
    });
    if (data && data.loginSuccess === true) {
      this.setState({
        isShowConfirmBookingModal: true,
      });
    }
  };

  onCloseConfirmBookingModal = async (bookingId) => {
    this.setState({ isShowConfirmBookingModal: false });
    if (!bookingId) {
      return;
    }
    this.dispatch.setUserBookingData({
      key: this.state.shopId,
      value: {
        chosenMenu: "",
        total: "",
        discount: "",
        duration: "",
        chosenTime: "",
        isUserChosenTime: false,
      },
    });

    this.props.history.push(
      `/${this.state.shopId}/booking/${bookingId}/booking-success`
    );
  };

  onConfirmButtonClick = () => {
    if (!this.props.user.userToken) {
      this.setState({ isShowLoginModal: true });
      return;
    }

    this.setState({ isShowConfirmBookingModal: true });
  };

  onCloseConfirmRemoveModal = (data) => {
    this.setState({ isShowRemoveDialog: false, removeType: "" });
  };

  gotoHistory = () => {
    this.props.history.push(`/${this.props.match.params.id}/booking/history`);
  };

  getMoney = (total, discount, timeDiscount) => {
    const isString = typeof timeDiscount === "string";
    return total || discount
      ? window.utils.formatMoney(
          total - discount - (isString ? 0 : timeDiscount),
          0,
          3,
          ",",
          "."
        )
      : 0;
  };

  render() {
    const {
      shopMenus,
      shopDiscounts,
      shopStaffs,
      userBookingData,
      userToken,
      shopDetail,
    } = this.props.user;
    const {
      total,
      discount,
      chosenStaff,
      chosenMenu: chosenMenuIds,
      chosenTime,
      isUserChosenTime,
    } = this.props.user.userBookingData;

    const {
      isShowLoginModal,
      isShowConfirmBookingModal,
      isShowRemoveDialog,
      removeType,
      willRemoveThing,
      timeDiscountValue,
      otherDiscountValue,
    } = this.state;
    const {
      removeMenu,
      removeChosenTime,
      onCloseConfirmBookingModal,
      onConfirmButtonClick,
      onCloseConfirmRemoveModal,
      removeStaff,
      getMoney,
      gotoHistory,
    } = this;

    let chosenMenu = [];
    if (userBookingData.chosenMenu) {
      chosenMenu = userBookingData.chosenMenu
        .split(",")
        .map((item) => shopMenus.find((menu) => menu.id === +item));

      chosenMenu = chosenMenu.map((menu) => {
        const discount = shopDiscounts.find(
          (discount) => discount.id === menu.discount
        );

        if (
          !discount ||
          !(
            moment(
              moment(discount.valid_to).format("YYYY-MM-DD HH:mm")
            ).isSameOrAfter(
              moment(chosenTime || new Date()).format("YYYY-MM-DD HH:mm")
            ) &&
            moment(
              moment(discount.valid_from).format("YYYY-MM-DD HH:mm")
            ).isSameOrBefore(
              moment(chosenTime || new Date()).format("YYYY-MM-DD HH:mm")
            )
          )
        ) {
          return menu;
        }

        let priceAfterDiscount = "";
        if (discount.type === constant.discountType.PERCENTAGE) {
          priceAfterDiscount =
            menu.price - (menu.price * Number(discount.value)) / 100;
        } else {
          priceAfterDiscount = menu.price - Number(discount.value);
        }

        return {
          ...menu,
          priceAfterDiscount,
        };
      });
    }

    const canPay = chosenStaff && chosenMenuIds && isUserChosenTime;

    return (
      <div id="user-booking-home" className="user-home fade-out">
        <div className="user-home__wrapper">
          <ColorWrapper
            className="user-home__ttl"
            $color={this.pageColor}
            $isColor
          >
            予約オプションを選択する
          </ColorWrapper>
          {shopDetail.booking_confirm ? (
            <p className="user-home__text-hint">
              店舗からお客さまへ予約受付の可否し、確認後に予約が確定します。
            </p>
          ) : (
            ""
          )}
          {userToken ? (
            <GoToHistoryButton
              buttonText={"予約履歴へ"}
              onClick={gotoHistory}
            />
          ) : (
            ""
          )}

          <div className="user-home__ctn-wrapper">
            <ul className="user-home__options options">
              <li className="options__item">
                <div className="options__header">
                  <figure>
                    <img src={iconUser} alt="cippo-booking"></img>
                  </figure>
                  <RequiredLabel className="options__label">
                    {window.store.getState().user.shopDetail.section_name_1}
                  </RequiredLabel>
                </div>
                {!chosenStaff ? (
                  <div className="options__description">
                    {window.store.getState().user.shopDetail.section_name_1}
                    を選択してください
                  </div>
                ) : (
                  <div className="options__chosen-menu">
                    <span
                      className="material-icons close-btn"
                      onClick={() =>
                        removeStaff(
                          shopStaffs.find((staff) => staff.id === chosenStaff)
                        )
                      }
                    >
                      close
                    </span>
                    <p className="staff-name">
                      {
                        shopStaffs.find((staff) => staff.id === chosenStaff)
                          .name
                      }
                    </p>
                  </div>
                )}
                <ColorWrapper
                  className="options__chose-btn"
                  $color={this.pageColor}
                  $isBorder
                  $isColor
                  onClick={() =>
                    this.changePage(
                      `/${this.props.match.params.id}/booking/staffs`
                    )
                  }
                >
                  選択する
                </ColorWrapper>
              </li>
              <li className="options__item">
                <div className="options__header">
                  <figure>
                    <img src={iconBook} alt="cippo-booking"></img>
                  </figure>
                  <RequiredLabel className="options__label">
                    メニュー
                  </RequiredLabel>
                </div>
                {!chosenMenu.length ? (
                  <div className="options__description">
                    メニューを選択してください
                  </div>
                ) : (
                  chosenMenu.map((menu) => (
                    <div
                      style={{ marginBottom: "6px" }}
                      key={menu.id}
                      className="options__description"
                    >
                      <div className="options__chosen-menu">
                        <span
                          className="material-icons close-btn"
                          onClick={() => removeMenu(menu)}
                        >
                          close
                        </span>
                        <span className="name">{menu.name}</span>
                        <div className="time">
                          <span className="material-icons">schedule</span>
                          <p>{menu.duration}分</p>
                        </div>
                        <div className="price">
                          ¥
                          {window.utils.formatMoney(
                            Number(menu.priceAfterDiscount || menu.price),
                            0,
                            3,
                            ",",
                            "."
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                )}
                <ColorWrapper
                  className="options__chose-btn"
                  $color={this.pageColor}
                  $isColor
                  $isBorder
                  onClick={() =>
                    this.changePage(
                      `/${this.props.match.params.id}/booking/menus`
                    )
                  }
                >
                  選択する
                </ColorWrapper>
                {chosenMenu.length ? (
                  <div className="options__total">
                    合計 ¥
                    {utils.formatMoney(
                      Number(total - discount),
                      0,
                      3,
                      ",",
                      "."
                    )}
                  </div>
                ) : (
                  ""
                )}
              </li>
              <li className="options__item">
                <div className="options__header">
                  <figure>
                    <img src={iconCalendar} alt="cippo-booking"></img>
                  </figure>
                  <RequiredLabel className="options__label last-one">
                    日時
                  </RequiredLabel>
                </div>
                {!isUserChosenTime ? (
                  <div className="options__description">
                    日時を選択してください
                  </div>
                ) : (
                  <div className="options__chosen-menu">
                    <span
                      className="material-icons close-btn"
                      onClick={() => removeChosenTime(chosenTime)}
                    >
                      close
                    </span>
                    <p className="staff-name">
                      {moment(chosenTime).format("YYYY/MM/DD (dd) HH:mm ~")}
                    </p>
                  </div>
                  // <div className="options__description">
                  //   <p className="staff-name">{moment(chosenTime).format()}</p>
                  // </div>
                )}
                <ColorWrapper
                  className="options__chose-btn"
                  $color={this.pageColor}
                  $isColor
                  $isBorder
                  onClick={() =>
                    this.changePage(
                      `/${this.props.match.params.id}/booking/time`
                    )
                  }
                >
                  選択する
                </ColorWrapper>
              </li>
            </ul>

            <div className="user-home__cart">
              <div className="cart-wrapper">
                {/* <ul className="user-home__cart-items">
                  <li></li>
                </ul> */}
                <div className="user-home__cart-money">
                  <span>見積金額</span>
                  <span>¥{getMoney(total, discount, otherDiscountValue)}</span>
                </div>
                <div className="user-home__cart-money mt-3 ">
                  <span>割引</span>
                  <span>
                    {discount ? (
                      <div className="text-end">¥{discount || 0}</div>
                    ) : (
                      "¥0"
                    )}
                    {otherDiscountValue && (
                      <div className="mt-2">{otherDiscountValue}</div>
                    )}
                    {timeDiscountValue && (
                      <div className="text-end mt-2">
                        {typeof timeDiscountValue === "string" ? "" : "¥"}{" "}
                        {timeDiscountValue}
                      </div>
                    )}
                  </span>
                </div>
              </div>
              <ButtonStyled
                $color={this.pageColor}
                className="user-home__confirm-btn"
                disabled={!canPay}
                style={{
                  backgroundColor: canPay ? this.pageColor : "",
                }}
                onClick={onConfirmButtonClick}
              >
                確定
              </ButtonStyled>
            </div>
          </div>
        </div>
        {isShowLoginModal ? (
          <LoginModal
            onClose={this.onCloseLoginModal}
            {...this.props}
          ></LoginModal>
        ) : (
          ""
        )}
        {isShowConfirmBookingModal ? (
          <ConfirmBookingModal
            onClose={onCloseConfirmBookingModal}
            {...this.props}
          />
        ) : (
          ""
        )}
        {isShowRemoveDialog ? (
          <ConfirmRemoveModal
            type={removeType}
            data={willRemoveThing}
            onClose={onCloseConfirmRemoveModal}
            {...this.props}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default DefaultContainer;
